import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { APOLLO_OPTIONS } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';
import { InMemoryCache, ApolloLink } from '@apollo/client/core';
// No longer using setContext as we'll rely on HTTP interceptors
import { onError } from '@apollo/client/link/error';
import { environment } from '../../environments/environment';

export function createApollo(httpLink: HttpLink) {
  // GraphQL endpoint
  const uri = `${environment.apiUrlSourceService}/graphql`;

  // Error handling link
  const errorLink = onError(({ graphQLErrors, networkError }) => {
    if (graphQLErrors) {
      graphQLErrors.forEach(({ message, locations, path }) => {
        console.error('[GraphQL error]: Message:', message);
        console.error('Location:', locations);
        console.error('Path:', path);
      });
    }
    if (networkError) {
      console.error('[Network error]:', networkError);
    }
  });

  // We'll rely on HTTP interceptors for authentication
  // instead of using setContext

  // Combine links
  const link = ApolloLink.from([
    errorLink,
    httpLink.create({ uri })
  ]);

  // Create and configure Apollo Client
  return {
    link,
    cache: new InMemoryCache(),
    defaultOptions: {
      watchQuery: {
        fetchPolicy: 'network-only',
        errorPolicy: 'all',
      },
      query: {
        fetchPolicy: 'network-only',
        errorPolicy: 'all',
      },
      mutate: {
        errorPolicy: 'all',
      },
    },
  };
}

@NgModule({
  imports: [
    HttpClientModule,
  ],
  providers: [
    {
      provide: APOLLO_OPTIONS,
      useFactory: createApollo,
      deps: [HttpLink],
    },
    // We're using the existing token interceptor for authentication
    // No need to add it here as it's already provided in the app module
  ]
})
export class GraphQLModule { }
